import { theme } from '@chakra-ui/react';
import { TickFormatter } from '@nivo/axes';
import { ResponsiveBar } from '@nivo/bar';
import React from 'react';

import { BarDatum } from '@/domain/models/Chart';
import { CurrencyDomainService } from '@/domain/services';

interface Props {
  data: BarDatum[];
  axisBottomFormatter: string | TickFormatter;
}

export const BarChart: React.FC<Props> = ({ data, axisBottomFormatter }) => {
  return (
    <ResponsiveBar
      data={data}
      indexBy="id"
      margin={{ top: 30, right: 20, bottom: 30, left: 50 }}
      padding={0.1}
      valueScale={{ type: 'linear' }}
      indexScale={{ type: 'band', round: true }}
      colors={theme.colors.blue[700]}
      axisBottom={{
        tickSize: 5,
        tickRotation: 0,
        legendPosition: 'middle',
        legendOffset: 32,
        format: axisBottomFormatter,
      }}
      axisLeft={{
        tickSize: 5,
        tickPadding: 5,
        tickRotation: 0,
        tickValues: 5,
        legendPosition: 'middle',
        legendOffset: -40,
        format: (value) => CurrencyDomainService.notationFormat(Number(value)),
      }}
      enableLabel={false}
      animate={true}
      motionStiffness={90}
      motionDamping={15}
      tooltip={({ indexValue, value, color }) => (
        <strong style={{ color }}>
          {indexValue}: {CurrencyDomainService.priceNotationFormat(value)}
        </strong>
      )}
    />
  );
};
